export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";